"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "nocera-inferiore": {
    "a9d5f94d": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "capocasale": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f2e321d": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "casolla-grotti": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4b58d6eb": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "merichi-cicalesi": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "469ddacd": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "metropolitano": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2f66ced6": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "quartieri-piedimonte-pietraccetta": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1ed3d6e": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "storico": [{
      "hkey": "af6b30a4",
      "slug": "nocera-inferiore",
      "name": "Nocera Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;